function formatVenueAddress({ buildingName, city, postCode, street }) {
    return [
        `${buildingName !== null ? `${buildingName} ` : ""} ${street}`,
        city,
        postCode
    ].filter(Boolean)
}

export default formatVenueAddress;
